import {
  drawerWidth,
  boxShadow,
  defaultFont,
  primaryColor,
  primaryBoxShadow,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  whiteColor,
  grayColor,
  blackColor,
  cabeceraColor,
  hexToRgb
} from "assets/jss/style.js";

const sidebarStyle = theme => ({
  drawerPaper: {
    border: "none",
    position: "fixed",
    top: "0",
    bottom: "0",
    left: "0",
    zIndex: "1",
    ...boxShadow,
    width: drawerWidth,
    height: "100%"
  },
  titleLogo: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    maxWidth: "145px",
    margin: "0"
  },
  logo: {
    position: "relative",
    padding: "5px 5px",
    zIndex: "4",
    height: "35px",
    color: "white",
    display: "flex",
    fontSize: "14px",
    textTransform: "uppercase",
    alignItems: "center"
  },
  logoLink: {
    ...defaultFont,
    textTransform: "uppercase",
    padding: "5px 0",
    display: "block",
    fontSize: "18px",
    textAlign: "left",
    fontWeight: "400",
    lineHeight: "30px",
    textDecoration: "none",
    backgroundColor: "transparent",
    "&,&:hover": { color: whiteColor }
  },
  logoImage: {
    width: "44px",
    paddingRight: "10px"
  },
  img: {
    width: "100%",
    border: "1px solid #fff",
    borderRadius: "150px",
    marginTop: "5px"
  },
  background: {
    position: "absolute",
    zIndex: "1",
    height: "100%",
    width: "100%",
    display: "block",
    top: "0",
    left: "0",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    "&:after": {
      position: "absolute",
      zIndex: "3",
      width: "100%",
      height: "100%",
      content: '""',
      display: "block",
      background: cabeceraColor[0],
      opacity: "1"
    }
  },
  list: {
    paddingLeft: "0 !important",
    paddingTop: "0 !important",
    paddingBottom: "0 !important",
    marginBottom: "0 !important",
    listStyle: "none",
    width: "unset",
    maxHeight: "calc(100vh - 132px)",
    position: "relative",
    overflow: "auto"
  },
  item: {
    position: "relative",
    display: "block",
    textDecoration: "none",
    "&:visited,&": {
      color: whiteColor
    },
    "&:hover,&:focus": {
      color: whiteColor,
      background: " #85b2cb7a !important"
    }
  },
  itemSubmenu: {
    width: "220px !important",
    display: "flex",
    color: "#042F41 !important",
    padding: "5px 10px !important",
    "&:hover,&:focus": {
      background: "#Ebedee !important"
    },
    fontSize: "11px !important",
    margin: "5px 0px !important"
  },
  itemLink: {
    width: "auto",
    transition: "all 300ms linear",
    margin: "0px",
    borderRadius: "3px !important",
    position: "relative",
    display: "block",
    padding: "5px 10px !important",
    backgroundColor: "transparent",
    ...defaultFont
  },
  itemIcon: {
    width: "20px !important",
    height: "30px !important",
    fontSize: "1rem !important",
    lineHeight: "30px",
    float: "left",
    marginRight: "10px",
    textAlign: "center",
    verticalAlign: "middle",
    color: "rgba(" + hexToRgb(whiteColor) + ", 0.8)"
  },
  itemText: {
    ...defaultFont,
    margin: "0 !important",
    lineHeight: "30px",
    fontSize: "12px",
    color: whiteColor
  },
  whiteFont: {
    color: whiteColor
  },
  purple: {
    backgroundColor: primaryColor[0],
    ...primaryBoxShadow,
    "&:hover,&:focus": {
      backgroundColor: primaryColor[0],
      ...primaryBoxShadow
    }
  },
  blue: {
    backgroundColor: infoColor[0] + "!important",
    boxShadow:
      "0 12px 20px -10px rgba(" +
      hexToRgb(infoColor[0]) +
      ",.28), 0 4px 20px 0 rgba(" +
      hexToRgb(blackColor) +
      ",.12), 0 7px 8px -5px rgba(" +
      hexToRgb(infoColor[0]) +
      ",.2)",
    "&:hover,&:focus": {
      backgroundColor: infoColor[0],
      boxShadow:
        "0 12px 20px -10px rgba(" +
        hexToRgb(infoColor[0]) +
        ",.28), 0 4px 20px 0 rgba(" +
        hexToRgb(blackColor) +
        ",.12), 0 7px 8px -5px rgba(" +
        hexToRgb(infoColor[0]) +
        ",.2)"
    }
  },
  gray: {
    backgroundColor: grayColor[12] + "!important",
    boxShadow:
      "0 12px 20px -10px rgba(" +
      hexToRgb(grayColor[12]) +
      ",.28), 0 4px 20px 0 rgba(" +
      hexToRgb(blackColor) +
      ",.12), 0 7px 8px -5px rgba(" +
      hexToRgb(grayColor[12]) +
      ",.2)",
    "&:hover,&:focus": {
      backgroundColor: grayColor[12],
      boxShadow:
        "0 12px 20px -10px rgba(" +
        hexToRgb(grayColor[12]) +
        ",.28), 0 4px 20px 0 rgba(" +
        hexToRgb(blackColor) +
        ",.12), 0 7px 8px -5px rgba(" +
        hexToRgb(grayColor[12]) +
        ",.2)"
    }
  },
  green: {
    backgroundColor: successColor[0],
    boxShadow:
      "0 12px 20px -10px rgba(" +
      hexToRgb(successColor[0]) +
      ",.28), 0 4px 20px 0 rgba(" +
      hexToRgb(blackColor) +
      ",.12), 0 7px 8px -5px rgba(" +
      hexToRgb(successColor[0]) +
      ",.2)",
    "&:hover,&:focus": {
      backgroundColor: successColor[0],
      boxShadow:
        "0 12px 20px -10px rgba(" +
        hexToRgb(successColor[0]) +
        ",.28), 0 4px 20px 0 rgba(" +
        hexToRgb(blackColor) +
        ",.12), 0 7px 8px -5px rgba(" +
        hexToRgb(successColor[0]) +
        ",.2)"
    }
  },
  orange: {
    backgroundColor: warningColor[0],
    boxShadow:
      "0 12px 20px -10px rgba(" +
      hexToRgb(warningColor[0]) +
      ",.28), 0 4px 20px 0 rgba(" +
      hexToRgb(blackColor) +
      ",.12), 0 7px 8px -5px rgba(" +
      hexToRgb(warningColor[0]) +
      ",.2)",
    "&:hover,&:focus": {
      backgroundColor: warningColor[0],
      boxShadow:
        "0 12px 20px -10px rgba(" +
        hexToRgb(warningColor[0]) +
        ",.28), 0 4px 20px 0 rgba(" +
        hexToRgb(blackColor) +
        ",.12), 0 7px 8px -5px rgba(" +
        hexToRgb(warningColor[0]) +
        ",.2)"
    }
  },
  red: {
    backgroundColor: dangerColor[0],
    boxShadow:
      "0 12px 20px -10px rgba(" +
      hexToRgb(dangerColor[0]) +
      ",.28), 0 4px 20px 0 rgba(" +
      hexToRgb(blackColor) +
      ",.12), 0 7px 8px -5px rgba(" +
      hexToRgb(dangerColor[0]) +
      ",.2)",
    "&:hover,&:focus": {
      backgroundColor: dangerColor[0],
      boxShadow:
        "0 12px 20px -10px rgba(" +
        hexToRgb(dangerColor[0]) +
        ",.28), 0 4px 20px 0 rgba(" +
        hexToRgb(blackColor) +
        ",.12), 0 7px 8px -5px rgba(" +
        hexToRgb(dangerColor[0]) +
        ",.2)"
    }
  },
  sidebarWrapper: {
    position: "relative",
    height: "100%",
    overflow: "auto",
    width: "190px",
    zIndex: "4",
    overflowScrolling: "touch",
    background: "rgba(" + hexToRgb(successColor[1]) + ", 0.9)"
  },
  panelUser: {
    textAlign: "center",
    color: "#fff",
    "&:after": {
      content: '""',
      position: "absolute",
      height: "1px",
      right: "15px",
      width: "calc(100% - 30px)",
      backgroundColor: "rgba(" + hexToRgb(grayColor[6]) + ", 0.3)"
    }
  },
  menuTitle: {
    height: "40px",
    minWidth: "180px",
    display: "flex",
    alignContent: "center",
    flexWrap: "wrap",
    paddingLeft: "10px",
    fontSize: "11px",
    color: "#042F41 !important",
    borderBottom: "1px solid rgba(0, 0, 0, 0.45)",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: "700"
  }
});

export default sidebarStyle;
